// extracted by mini-css-extract-plugin
export default {"main_page":"MainPage_main_page__0bxWF"};